import { requestGet, requestPost } from '@/utils/request';

// 列举指定批次的奖励
export function getRewardList(campId: string, batchId: string) {
  return requestGet(`/v2/camp/api/reward/list?campId=${campId}&batchId=${batchId}`, {});
}

export function postReceiveReward(params: any) {
  return requestPost(`/v2/camp/api/reward/receive/reward`, params);
}
